import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface DrywallProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Drywall: React.FC<DrywallProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [drywall, set_drywall] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Drywall']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Drywall': [b.values?.['Interior']?.['Drywall']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Drywall';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(drywall)}
                />
            ) : (
                <MoneyBox
                    id={'drywall'}
                    allowNegative={false}
                    value={drywall}
                    onChange={(value) => set_drywall(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
